module.exports = __webpack_public_path__ + "img/graph_NL.2a3ae657.jpg";